module.exports = __webpack_public_path__ + "img/pr-1.8fd37329.png";